export default __webpack_public_path__ + "static/media/bank-cs.dec1e466.svg";